<template>
  <div class="page-ntralist" v-show="isMounted">
    <div class="common-wrap">
      <div class="paeparation">
        <div class="search">
          <el-input class="ipt" clearable size="large" v-model="storyParam.productionName" placeholder="搜索你感兴趣的关键词"></el-input>
          <div class="btn"  v-on:click="changePage(1)">
            <i class="el-icon-search"></i> 搜索
          </div>
        </div>
        <div class="types-list">
          <div class="type-item clearfix">
            <div class="tit">主题：</div>


            <ul class="cases clearfix">
              <li :class="childTypes[0] && storyParam.productionType == childTypes[0].parentId?'active':''" v-on:click="selectProTypeChild(childTypes[0].parentId,1)">全部</li>
              <li :class="storyParam.productionType == item.id?'active':''" v-on:click="selectProTypeChild(item.id,2)" v-for="(item,index) in childTypes" :key="index">{{item.tag}}</li>
            </ul>

          </div>
          <div class="type-item clearfix">
            <div class="tit">朝代：</div>
            <ul class="cases clearfix">
              <li :class="storyParam.groupType == ''?'active':''" v-on:click="selectProTypeHis(0)">全部</li>
              <li :class="storyParam.groupType == item.id ?'active':''" v-for="(item,index) in historyList" :key="index" v-on:click="selectProTypeHis(item.id)">{{item.tag}}</li>
            </ul>
          </div>
        </div>
      </div>


      <div class="projn-list nproject" >


        <div class="projn-item" v-for="(item,index) in newProductionPage.list" :key="index">
          <a :href="baseUrl+'/workstory?id='+item.id+'&plate='+item.belongSection" class="left-img" target="_blank" :style="{backgroundImage: 'url(' + item.productionCover + ')'}"></a>
          <a :href="baseUrl+'/workstory?id='+item.id+'&plate='+item.belongSection" target="_blank" class="mobile-mask"></a>
          <div class="itemn-info">
            <div class="item-tit">
              <div class="tit-type clearfix">
                <a :href="baseUrl+'/workstory?id='+item.id+'&plate='+item.belongSection" target="_blank" class="tit-nam">{{item.productionName}}</a>
                <span class="type tp" :title="item.tagStr">{{item.tagStr}}</span>
              </div>
              <a :href="baseUrl+'/home?userId='+item.creatorId" target="_blank"  class="user-info clearfix">
                <img class="u-avatar" :src="item.imgUrl" alt="">
                <span class="name">{{ item.creatorName }}</span>
              </a>
            </div>
            <a :href="baseUrl+'/workstory?id='+item.id+'&plate='+item.belongSection" target="_blank" class="pro-type">{{item.productionInrto}}</a>
            <div class="btn-has-user">
              <div class="left-info clearfix">
                <i class="icon view"></i>
                <span class="count">{{item.viewCount}}</span>
                <i class="icon zan"></i>
                <span class="count">{{item.likeCount}}</span>
                <i class="icon pinglun"></i>
                <span class="count">{{item.commentCount}}</span>
              </div>
              <div class="hs-user">{{item.createTime | formatTime}}</div>
            </div>
          </div>
        </div>




      </div>
      <div class="pagintion-f"  v-if="isMounted && newProductionPage.total>0">
        <el-pagination
                background
                @current-change="changePage"
                layout="prev, pager, next,jumper"
                :current-page.sync="storyParam.pageIndex"
                :page-size="storyParam.pageSize"
                :total="newProductionPage.total"
                :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
<!--      <div class="pagintion-f"  v-show="isMounted && newProductionPage.total>0">-->
<!--        pageIndex:{{storyParam.pageIndex}}-->
<!--        <el-pagination-->
<!--                background-->
<!--                @current-change="changePage"-->
<!--                layout="prev, pager, next,jumper"-->
<!--                :current-page.sync="storyParam.pageIndex"-->
<!--                :page-size="storyParam.pageSize"-->
<!--                :total="newProductionPage.total"-->
<!--                :hide-on-single-page="true"-->
<!--        >-->
<!--        </el-pagination>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import productionApi from "@/api/production";
  import updateTdk from "@/utils/tdk";
  import tagsApi from "@/api/tags";
  import utilTools from "@/utils/utilTools";
  import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['newProductionPage'])
  },
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "人人动画",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      tagParam:{
        parentId:-1,
        classify: 0,  //官方创建标签
      },
      tagList:[],
      searchIpt: '',

      childTypes:[],
      threeTypes:[],

      historyParam:{
        status:1,
        type:3 //故事所属----标签
      },
      historyList:[],


      storyParam:{
        productionName:"",
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 6,
        productionForm:3, //文章---（故事剧本）
        belongSection:"2", //传统文化
        productionType:96, //故事ID
        productionTags:'',
        groupType:'',
      },
      total:0,
      storyData:[],
      parameTagStr:'',
      storyProType:96,
      //stroyDataTags:'', //全部 可筛选 标签
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    this.fetchData()
    return this.initData();
  },
  // beforeRouteUpdate(to, from, next) {
  //   // 一般建议路由变更采用计算属性或者store直接绑定
  //   // 特殊情况处理可以采用如下方案 重新注册数据返回处理
  //   this.initData()
  //   next();
  // },
  mounted(){
    // const alreadyProductionPage = !!this.newProductionPage
    //
    // console.log("alreadyProductionPage===",alreadyProductionPage)
    // console.log("alreadyProductionPage===",this.newProductionPage)

    this.fetchData()
    this.initData().then(()=>{
      this.parseHtml(this.newProductionPage.list)
      this.fetchDataMounted()
    })
  },
  methods:{
    parseHtml(list){
      list.forEach(item=>{
        //let desc = item.productionInrto.replace(/<\/?.+?>/g,"").trim()
        let desc = utilTools.parseHtml(item.productionInrto)
        item.productionInrto =desc//.substr(0,80);
      })
    },
    fetchData(){
      let paramPageIndex = this.$route.query.toPageNum
      let pName = this.$route.query.pName
      let ptype = this.$route.query.ptype
      let gtype = this.$route.query.gtype

      if(!paramPageIndex){
        paramPageIndex = 1
      }
      if(pName){
        this.storyParam.productionName = pName
      }
      if(ptype){
        this.storyParam.productionType = ptype
      }
      if(gtype){
        this.storyParam.groupType = gtype
      }

      this.storyParam.pageIndex = Number(paramPageIndex)
    },
    fetchDataMounted(){
      setTimeout(()=>{
        this.isMounted = true
        //初始化 故事分类的子分类
        this.tagParam.parentId = this.storyProType
        tagsApi.getList(this.tagParam).then(reTag => {
          this.childTypes = reTag.response
          tagsApi.getList(this.historyParam).then(re =>{
            this.historyList = re.response
            //this.search(this.storyParam.pageIndex)
          })

        })
      },1000)
    },
    initData(){
      this.$loading(true)
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store.dispatch("FETCH_NEW_PRODUCTION_LIST", {params: this.storyParam,cookies:cookies}).finally(() => {
        this.$loading(false)
        this.setSeo();
        updateTdk.call(this);
      })
    },
    setSeo() {
      this.headTitle = "人人动画网【官网】";
      this.headKeywords = "人人动画网,动画短视频,短视频";
      this.headDesc =
              "人人动画网，是一个动画短视频分享社区，凭借丰富的快速动画创意资源，和行业深厚的动画技术背景，助力每个人实现自己的动画梦。";
    },
    searchByTags(tagId){

    },
    search(){
      productionApi.pageV2PorductionList(this.storyParam).then(rePro => {
        this.storyData = rePro.list
        // this.storyData.forEach(item=>{
        //   //let desc = item.productionInrto.replace(/<\/?.+?>/g,"").trim()
        //   let desc = utilTools.parseHtml(item.productionInrto)
        //   item.productionInrto =desc//.substr(0,80);
        // })
        this.total = rePro.total
        //this.storyParam.pageIndex = rePro.pageNum
      })
    },
    changePage(page){
      let urlNow=window.location.href

      if(urlNow.indexOf("toPageNum") > 0){
        urlNow = urlNow.substr(0,urlNow.indexOf("&toPageNum="))
      }

      let url = urlNow+"&toPageNum="+page
      if(this.storyParam.productionType){
        url += "&ptype="+this.storyParam.productionType
      }
      if(this.storyParam.groupType){
        url += "&gtype="+this.storyParam.groupType
      }

      if(this.storyParam.productionName){
        url += "&pName="+this.storyParam.productionName
      }
      window.location.href= url
    },



    /*getProTypeChildThree(id){
      this.threeTypes =[]
      this.tagParam={}
      this.tagParam.parentId = id
      tagsApi.getList(this.tagParam).then(reThreeTag => {
        reThreeTag.response.forEach(re =>{
          this.threeTypes.push(re)
        })
      })
    },*/

    //作品子类型 查询--
    selectProTypeChild (id,type) {
      ///感觉没用 待删除 this.childTabIndex = index
      console.log("选择作品子类型 ==============",id)
      this.storyParam.productionType = id
      this.storyParam.productionTags=''
      this.parameTagStr = ''
      this.isAtt = true
      /*if(type == 2){
        this.getProTypeChildThree(id)
      }
      if(type == 1){*/
        this.changePage(1)
      /*}*/
    },

    selectProTypeHis(id){
      if(id == 0){
        this.storyParam.groupType = ''
      }else {
        this.storyParam.groupType = id
      }
      //this.search(1)
      this.changePage(1)
    },
  }
}
</script>

<style scoped lang="less">
@import "../../project/pro.less";
.page-ntralist {
  padding-top: @NAVHEIGHT;

}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
</style>
